import { MapPin, Clock, Bookmark } from 'lucide-react';
import TabGrid from '@/components/ui/TabGrid';

/**
 * Parking Tab Configuration
 * Soft pastel lavender palette
 */
const TAB_CONFIG = [
  {
    id: 'active',
    label: 'Active',
    icon: MapPin,
    colors: {
      bg: '#F5F3FF',
      active: '#E9E5FD',
      text: '#5B21B6',
      iconBg: '#DDD6FE',
    }
  },
  {
    id: 'history',
    label: 'History',
    icon: Clock,
    colors: {
      bg: '#F3F4F6',
      active: '#E5E7EB',
      text: '#6B21A8',
      iconBg: '#E9D5FF',
    }
  },
  {
    id: 'places',
    label: 'Saved',
    icon: Bookmark,
    colors: {
      bg: '#F5F3FF',
      active: '#E9E5FD',
      text: '#5B21B6',
      iconBg: '#DDD6FE',
    }
  }
];

const TABS_ORDER = ['active', 'history', 'places'];

/**
 * ParkingTabs - Grid-based tab navigation for Parking module
 * All tabs visible at once - no scrolling, no hidden features
 */
const ParkingTabs = ({ activeTab, onTabChange, children }) => {
  return (
    <TabGrid
      tabs={TAB_CONFIG}
      activeTab={activeTab}
      onTabChange={onTabChange}
      testIdPrefix="parking-tab"
    >
      {children}
    </TabGrid>
  );
};

export { TAB_CONFIG, TABS_ORDER };
export default ParkingTabs;
